const getUserInfo = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise((resolve, reject) => {
    const {
      success,
      fail,
      complete
    } = options;
    try {
      window.GaodunJSBridge.call({
        handlerName: 'getUserInfo',
        success: res => {
          if (success) {
            success(res);
          }
          resolve(res);
        },
        fail: res => {
          if (fail) {
            fail(res);
          }
          reject(res);
        },
        complete: res => {
          if (complete) {
            complete(res);
          }
        }
      });
    } catch (e) {
      resolve(e);
    }
  });
};
export default getUserInfo;